'use es6';

export const applyXYHideLegend = (visualization, report) => visualization.setIn(['style', 'showLegend'], !report.getIn(['displayParams', 'hideLegend']));